import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AkmfNgSharedModule } from '@akmf/ng-shared';
import { AlertComponent } from './alert/alert.component';

@NgModule({
  declarations: [AlertComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, AkmfNgSharedModule, TranslateModule],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, AkmfNgSharedModule, TranslateModule, AlertComponent],
})
export class SharedModule {}
